import vue from "vue";
import App from "./App.vue";
import App3 from "./Support.vue";
import NonListed from "./NonListed.vue";
import Meta from "vue-meta";
import PageNotFound from "./PageNotFound.vue";
import Blog from "./Blog.vue";
import Search from "./Search.vue";
import AstralFSN from "./AstralFSN.vue";
import AstralFSNPage from "./AstralFSNPage.vue";
import Privacy from "./Privacy.vue";
import { scroll } from "./mixins/index";
import "./css/style.scss";
import VueRouter from "vue-router";
import VTooltip from "v-tooltip";
import { getCategory } from "./assets/region/categoryMap";
import { getCategoryTranslation } from "./assets/region/categoryMap";
import { getTranslation } from "./assets/region/translations";

import axios from "axios"; // https://github.com/axios/axios
import es6promise from "es6-promise"; // es6-promise polyfill
import jQuery from "jquery"; // http://api.jquery.com
import anime from "animejs"; // https://github.com/juliangarnier/anime
import inView from "in-view"; // https://github.com/camwiegert/in-view
import VueClipboard from "vue-clipboard2";
import lottie from "lottie-web";
import VueMasonry from "vue-masonry-css";
import IdleVue from "idle-vue";
import Vuex from "vuex";
import VueSweetalert2 from "vue-sweetalert2";

import "sweetalert2/dist/sweetalert2.min.css";

// Vue cookies
import VueCookies from "vue-cookies";

// Vue Scrollspy
import Scrollspy from "vue2-scrollspy";

// use min version
import swiper from "swiper/js/swiper.min.js";

const checkSiteUrl = localStorage.getItem("siteUrl");
if (!checkSiteUrl) {
  localStorage.setItem("siteUrl", window.location.origin);
}

const components = require("./components/index").default;

// new Vue({
//   render: h => h(App)
// }).$mount("#app");
window.bus = new vue();
window.$ = jQuery;
window.axios = axios;
window.anime = anime;
window.swiper = swiper;
window.lottie = lottie;

// ie11 promise polyfill
es6promise.polyfill();

vue.use(VueClipboard);
vue.use(VueMasonry);
vue.use(VueCookies);
vue.use(Scrollspy);
vue.use(VueSweetalert2);
vue.use(VueRouter);
vue.use(VTooltip);
vue.use(Meta);

Object.keys(components).forEach((key) => {
  vue.component(key, components[key]);
});

vue.prototype.$getCategory = getCategory;
vue.prototype.$getCategoryTranslation = getCategoryTranslation;
vue.prototype.$getTranslation = getTranslation;

vue.use(Vuex);
const store = new Vuex.Store({
  // ...
  state: {
    showLinks: false,
    userId: "",
    country: "",
  },
  mutations: {
    setShowLinks(state, payload) {
      state.showLinks = payload;
    },
    setUserId(state, payload) {
      state.userId = payload;
    },
    setCountry(state, payload) {
      state.country = payload;
    },
  },
  actions: {
    setShowLinks(context) {
      context.commit("setShowLinks");
    },
    setUserId(context, payload) {
      context.commit("setUserId", payload);
    },
    setCountry(context, payload) {
      context.commit("setCountry", payload);
    },
  },
});

const eventsHub = new vue();
// window.bus = new vue();
vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 1800000, //  30 minutes
});

const Base = { template: "<div><router-view></router-view></div>" };

const routes = [
  { path: "/", component: App },
  { path: "/astralfsn", component: AstralFSN },
  { path: "/page-technique-astral-fsn-2023-phase-2", component: AstralFSNPage },
  {
    path:
      "/:region(en-.{2}|pt-br|es-xl|zh-cn|sv-se|nb-no|fi-fi|da-dk|de-de|fr-fr|de-ch|fr-ch|it-it|es-sp|ja-jp)/non-listed",
    component: NonListed,
  },
  {
    path:
      "/:region(en-.{2}|pt-br|es-xl|zh-cn|sv-se|nb-no|fi-fi|da-dk|de-de|fr-fr|de-ch|fr-ch|it-it|es-sp|ja-jp)/search",
    component: Search,
  },
  {
    path:
      "/:region(en-.{2}|pt-br|es-xl|zh-cn|sv-se|nb-no|fi-fi|da-dk|de-de|fr-fr|de-ch|fr-ch|it-it|es-sp|ja-jp)/support/privacy-policy",
    component: Privacy,
  },
  {
    path:
      "/:region(en-.{2}|pt-br|es-xl|zh-cn|sv-se|nb-no|fi-fi|da-dk|de-de|fr-fr|de-ch|fr-ch|it-it|es-sp|ja-jp)/support",
    component: Base,
    children: [
      {
        path: ":article",
        component: App3,
      },
      {
        path: "/",
        component: Blog,
      },
    ],
  },
  {
    path:
      "/:region(en-.{2}|pt-br|es-xl|zh-cn|sv-se|nb-no|fi-fi|da-dk|de-de|fr-fr|de-ch|fr-ch|it-it|es-sp|ja-jp)",
    component: Base,
    children: [
      {
        path: "404*",
        component: PageNotFound,
      },
      {
        path: ":category/:slug",
        component: App,
      },
      {
        path: ":slug",
        component: App,
      },
      {
        path: "/",
        component: App,
      },
    ],
  },
  { path: "*", name: "404", component: PageNotFound },
];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  mode: "history",
  routes, // short for `routes: routes`
});

// vue.use(router);

new vue({
  // name: "app",
  // el: "#app",
  // render: (h) => h(App),
  template: "<router-view/>",
  store,
  router,
  data: {
    isIdle: "Hello",
    browser: null,
    windows: false,
    tablet: false,
    mode: "",
    orientation: "",
    navigation: {
      active: false,
    },
    site: "",
    // datalayer: dataLayer, // gtm
  },
  onIdle() {
    this.isIdle = true;
  },
  onActive() {
    this.isIdle = false;
  },
  mixins: [scroll],
  watch: {
    mode(arg, prev) {
      bus.$emit("mode", [arg, prev]);

      if (arg === "lg" || arg === "xl") {
        bus.$emit("hamburger:mobile-search", false);
        bus.$emit("hamburger:active", false);
      }
    },
  },
  methods: {
    lottieIESvgResize() {
      if (this.browser !== "is-ie") {
        return;
      }

      // const $el = $(el);
      const width = $el.width();
      const $svg = $el.find("svg");

      const ratio = width / $svg.attr("width");
      $svg.width(width);
      $svg.height($svg.attr("height") * ratio);
    },
    matchMedia() {
      this.mode = "xs";
      if (matchMedia("(min-width: 576px)").matches) {
        this.mode = "sm";
      }
      if (matchMedia("(min-width: 768px)").matches) {
        this.mode = "md";
      }
      if (matchMedia("(min-width: 992px)").matches) {
        this.mode = "lg";
      }
      if (matchMedia("(min-width: 1200px)").matches) {
        this.mode = "xl";
      }

      // orientation
      this.orientation = "portrait";
      if (matchMedia("(orientation: landscape)").matches) {
        this.orientation = "landscape";
      }
    },
  },
  mounted() {
    // simple browser detection
    if (navigator.userAgent.match(/Firefox/)) {
      this.browser = "is-gecko";
    } else {
      if (navigator.userAgent.match(/Chrome/)) {
        this.browser = "is-chrome";
      } else {
        if (navigator.userAgent.match(/Safari/)) {
          this.browser = "is-safari";
        }
      }
    }

    if (navigator.userAgent.match(/Edge/)) {
      this.browser = "is-edge";
    }

    if (navigator.userAgent.match(/Trident/)) {
      this.browser = "is-ie";
    }

    // detect win. issues related to font cern bold.
    // load a different font file on win.
    if (navigator.userAgent.match(/Win/)) {
      this.windows = true;
    }

    // detect tablet
    if (navigator.userAgent.match(/iPad/) && ["lg", "xl"].includes(this.mode)) {
      this.tablet = "iPad Pro";
    }

    // entry: transition in-view
    inView.threshold(0.2);
    inView(".-transition-in-view")
      .on("enter", (el) => {
        el.classList.add("-in-view-active");
      })
      .on("exit", (el) => {
        el.classList.remove("-in-view-active");
      });

    // output (log) component names
    let components = [];
    $(".page > section").each(function(index, el) {
      components.push($(el).attr("resmed-component-name"));
    });

    // documents tooltip (close)
    // component-d741a204
    document.body.addEventListener(
      "click",
      () => {
        bus.$emit("component-d741a204:active", "");
      },
      true
    );

    // app mounted
    this.$nextTick(() => {
      bus.$emit("app.mounted", true);

      // because of IE 11
      // do not use bind class [browser]
      $(this.$el).addClass(this.browser);
    });
  },
  created() {
    let arr = location.pathname.split("/").filter((e) => e);
    this.site = "default";

    if (["sleep-apnea", "portable-oxygen", "ventilation"].includes(arr[1])) {
      this.site = arr[1];
    }

    this.matchMedia();

    $(window).on("resize", () => {
      this.matchMedia();
    });

    bus.$on("hamburger:active", (arg) => {
      this.navigation.active = arg;
    });
  },
}).$mount("#app");

// new vue({
//   render: h => h(App)
// }).$mount("#app");
